import { render, staticRenderFns } from "./upcoming-lesson-item.vue?vue&type=template&id=53cbea64&scoped=true"
import script from "./upcoming-lesson-item.vue?vue&type=script&lang=js"
export * from "./upcoming-lesson-item.vue?vue&type=script&lang=js"
import style0 from "./upcoming-lesson-item.vue?vue&type=style&index=0&id=53cbea64&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53cbea64",
  null
  
)

export default component.exports